import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as i0 from "@angular/core";
import * as i1 from "ngx-ui-loader";
var DEFAULT = 'default';
var LoadingService = /** @class */ (function () {
    function LoadingService(loadingSvc) {
        this.loadingSvc = loadingSvc;
        this.numPending = new Map([[DEFAULT, 0]]);
    }
    Object.defineProperty(LoadingService.prototype, "loading", {
        get: function () {
            return this.isLoading();
        },
        enumerable: true,
        configurable: true
    });
    LoadingService.prototype.isLoading = function (spinner) {
        if (spinner === void 0) { spinner = DEFAULT; }
        return (this.numPending.get(spinner) || 0) > 0;
    };
    LoadingService.prototype.show = function (spinner) {
        if (spinner === void 0) { spinner = DEFAULT; }
        var pending = (this.numPending.get(DEFAULT) || 0) + 1;
        this.numPending.set(spinner, pending);
        this.loadingSvc.start(spinner); //show(spinner);
        if (pending === 1) {
            console.log('loading started');
        }
    };
    LoadingService.prototype.hide = function (spinner) {
        if (spinner === void 0) { spinner = DEFAULT; }
        console.log('loading hide called');
        var pending = (this.numPending.get(DEFAULT) || 0) - 1;
        this.numPending.set(spinner, pending > 0 ? pending : 0);
        console.log('loading hide has', pending, 'open items');
        if (pending <= 0) {
            this.loadingSvc.stop(spinner); //hide(spinner);
            console.log('loading done');
        }
    };
    LoadingService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoadingService_Factory() { return new LoadingService(i0.ɵɵinject(i1.NgxUiLoaderService)); }, token: LoadingService, providedIn: "root" });
    return LoadingService;
}());
export { LoadingService };
